"use strict"

module.exports = require("./stream/stream")



//////////////////
// WEBPACK FOOTER
// ./node_modules/mithril/stream.js
// module id = 12
// module chunks = 0